import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

// ---- Translations ----
// Add or edit keys here. English is the fallback for any missing Tamil key.
export const TRANSLATIONS = {
  en: {
    // Brand / meta
    brand: "Varuna Inn",
    brand_sub: "Assets & Laundry Management",
    tagline: "Complete laundry and asset control for hospitality.",
    tagline_sub: "Track every linen item, room amenity and hotel asset across stores, rooms, laundry and maintenance—with secure audit trails and real-time visibility.",
    laundry_management: "LAUNDRY MANAGEMENT",
    // Nav
    "nav.dashboard": "Dashboard",
    "nav.master_stock": "Master Linen Stock",
    "nav.housekeeping": "Daily Housekeeping Entry",
    "nav.rooms": "Room-wise Linen Status",
    "nav.room_par": "Room Linen Par",
    "nav.laundry": "Laundry In / Laundry Out",
    "nav.store": "Store Inventory",
    "nav.checkout": "Checkout Dirty Linen",
    "nav.missing_damaged": "Missing & Damaged",
    "nav.purchases": "Purchase Register",
    "nav.consumption": "Monthly Consumption Report",
    "nav.closing": "Daily Physical Closing",
    "nav.discrepancies": "Discrepancy Review",
    "nav.assets": "Asset Management",
    "nav.admin": "Admin Settings",
    "nav.audit": "Audit Log",
    "nav.system": "System",
    // Page subtitles
    "sub.master_stock": "Current accountable balance per item across every location.",
    "sub.housekeeping": "Record linen placed, removed, found dirty, missing or damaged in a room.",
    "sub.rooms": "22 rooms · showing par, current clean, and dirty checkout counts.",
    "sub.laundry": "Dispatch dirty linen to vendors and receive it back.",
    "sub.store": "Clean linen ready for issue.",
    "sub.checkout": "Housekeeping tasks generated when Front Office marks a room Checked Out/Dirty.",
    "sub.missing_damaged": "Missing reports do not deduct stock until Admin approves a loss. Damaged items sit in Quarantine until disposed.",
    "sub.purchases": "New stock received. Only approved purchases increase the owned total.",
    "sub.consumption": "Consumption = approved loss + disposal. Room issues and laundry are location moves.",
    "sub.closing": "Enter physical counts. Variances require a remark and Supervisor approval.",
    "sub.admin": "Configure the hotel, users, items, rooms, par values, vendors, and opening stock.",
    "sub.audit": "Every login, submission, approval, correction, and configuration change.",
    // Common actions
    "action.save": "Save", "action.cancel": "Cancel", "action.submit": "Submit",
    "action.add": "Add", "action.delete": "Delete", "action.close": "Close",
    "action.approve": "Approve", "action.reject": "Reject", "action.print": "Print / PDF",
    "action.excel": "Excel", "action.csv": "CSV", "action.export": "Export",
    "action.open": "Open", "action.detail": "Detail",
    // Column headers
    "col.item": "Item", "col.qty": "Qty", "col.date": "Date", "col.status": "Status",
    "col.remarks": "Remarks", "col.reason": "Reason", "col.actions": "Actions",
    "col.by": "By", "col.role": "Role", "col.attachment": "Attachment",
    "col.room": "Room", "col.vendor": "Vendor", "col.supplier": "Supplier", "col.ref": "Reference",
    "hk.op_date": "Operational Date",
    "hk.room_status": "Update Room Status (optional)",
    "hk.line_items": "Line Items",
    "hk.action": "Action",
    "hk.add_item": "Add another item",
    "hk.submit": "Submit housekeeping entry",
    "hk.act.place": "Place in Room (from Store)",
    "hk.act.remove": "Remove from Room (to Store)",
    "hk.act.dirty": "Found Dirty (to Dirty Holding)",
    "hk.act.missing": "Report Missing",
    "hk.act.damage": "Report Damage",
    "lnd.tab.new": "New Dispatch",
    "lnd.tab.receive": "Receive Return",
    "lnd.tab.history": "Dispatch History",
    "lnd.vehicle": "Vehicle / Driver",
    "lnd.items_dispatch": "Items to Dispatch (from Dirty Holding)",
    "lnd.create_dispatch": "Create Dispatch",
    "lnd.return_date": "Return date",
    "lnd.move_to": "Move to",
    "lnd.returned_await": "Returned Awaiting",
    "lnd.direct_store": "Direct to Store Clean",
    "lnd.dispatched": "Dispatched",
    "lnd.outstanding": "Outstanding",
    "lnd.received": "Received",
    "lnd.rejected": "Rejected/Damaged",
    "lnd.missing": "Missing",
    "lnd.submit_receipt": "Submit Receipt",
    "lnd.attach_challan": "Attachment (challan photo / PDF)",
    "lnd.attach_delivery": "Attachment (delivery note / PDF)",
    "pur.reference": "Reference / PO Number",
    "pur.receive_into": "Receive Into",
    "pur.add_line": "Add line",
    "pur.attach": "Attachment (invoice photo / PDF)",
    "pur.record": "Record Purchase",
    "pur.line_items": "Line Items",
    "cls.tab.new": "New Closing",
    "cls.tab.list": "History & Approval",
    "cls.date": "Closing Date",
    "cls.overall": "Overall Remarks",
    "cls.location": "Location",
    "cls.expected": "Expected (System)",
    "cls.physical": "Physical Count",
    "cls.variance": "Variance",
    "cls.remark": "Remark",
    "cls.submit": "Submit Physical Closing",
    "action.save": "Save", "action.cancel": "Cancel", "action.submit": "Submit",
    "action.add": "Add", "action.close": "Close", "action.approve": "Approve",
    "action.reject": "Reject", "action.print": "Print / PDF", "action.excel": "Excel", "action.csv": "CSV",
    // Auth
    "auth.sign_in": "Sign in",
    "auth.sign_out": "Sign out",
    "auth.enter_credentials": "Enter your credentials to continue.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signing_in": "Signing in…",
    "auth.welcome": "Welcome to Varuna Inn",
    "auth.invalid": "Invalid credentials",
    "auth.forgot_password": "Forgot password?",
    "auth.forgot_title": "Reset your password",
    "auth.forgot_help": "Enter the email you use to sign in. If we find an account, we'll email a secure link to set a new password.",
    "auth.send_reset_link": "Send reset link",
    "auth.sending": "Sending…",
    "auth.reset_link_sent": "Reset link sent.",
    "auth.reset_check_email": "Check your email inbox for the reset link.",
    "auth.reset_sent_body": "If an account exists for that email, you'll receive a reset link within a minute. The link is valid for 30 minutes and can only be used once.",
    "auth.try_another_email": "Try another email",
    "auth.back_to_signin": "Back to sign in",
    "auth.reset_title": "Choose a new password",
    "auth.reset_help": "Pick something you can remember but hard for others to guess. Minimum 10 characters.",
    "auth.new_password": "New password",
    "auth.confirm_password": "Confirm new password",
    "auth.reset_action": "Reset password",
    "auth.resetting": "Resetting…",
    "auth.reset_missing_token": "This reset link is missing its token. Please request a fresh reset email.",
    "auth.reset_success_body": "Your password has been reset. Redirecting you to sign in…",
    "auth.pwd_reset_ok": "Password updated. You can sign in now.",
    "auth.pwd_min6": "Password must be at least 10 characters.",
    "auth.pwd_min10": "Password must be at least 10 characters.",
    "auth.pwd_mismatch": "Passwords do not match.",
    "auth.pwd_same_as_current": "New password must be different from the current password.",
    "auth.something_went_wrong": "Something went wrong. Please try again.",
    "auth.change_pwd_title": "Change your password",
    "auth.change_pwd_help": "Enter your current password and choose a new one.",
    "auth.first_login_pwd_help": "You must change your temporary password before continuing.",
    "auth.current_password": "Current password",
    "auth.change_pwd_action": "Change password",
    "auth.pwd_changed_ok": "Password changed.",
    "auth.saving": "Saving…",
    // Roles
    "role.admin": "Admin",
    "role.accounts": "Accounts",
    "role.hk_supervisor": "HK Supervisor",
    "role.hk_staff": "HK Staff",
    "role.laundry": "Laundry",
    "role.front_office": "Front Office",
    "role.maintenance": "Maintenance",
    // Nav additions
    "nav.maintenance": "Maintenance",
    "nav.warranty": "Warranty & AMC",
    // Dashboard
    "dash.title": "Management Dashboard",
    "dash.sub": "Live from the append-only stock ledger.",
    "kpi.total": "Total Linen Stock",
    "kpi.rooms": "Linen in Rooms",
    "kpi.laundry_pending": "Laundry Pending",
    "kpi.dirty": "Dirty Linen",
    "kpi.store": "Store Balance",
    "kpi.available": "Available Stock",
    "kpi.missing": "Missing Linen",
    "kpi.damaged": "Damaged Linen",
    "low_stock_alerts": "Low Stock Alerts",
    "attention_needed": "Attention Needed Today",
    "overdue_laundry": "Overdue Laundry",
    "unclosed_checkouts": "Unclosed Checkouts",
    "missing_closings": "Missing Daily Closings",
    "pending_approval": "Pending Supervisor Approval",
    "chart.stock_by_location": "Stock by Location",
    "chart.laundry_monthly": "Monthly Laundry Sent vs Returned",
    "chart.items_vs_threshold": "Item-wise Available vs Threshold",
    "chart.purchase_vs_consumption": "Purchases vs Approved Consumption",
    // Common
    "search": "Search item, size, category…",
    "loading": "Loading…",
    "language": "Language",
  },
  ta: {
    brand: "வருணா இன்",
    brand_sub: "சொத்து & துணி மேலாண்மை",
    tagline: "விடுதிக்கான முழுமையான துணி மற்றும் சொத்து கட்டுப்பாடு.",
    tagline_sub: "கிடங்குகள், அறைகள், துணி துவைப்பு மற்றும் பராமரிப்பு முழுவதும் ஒவ்வொரு துணி, அறை வசதி மற்றும் விடுதி சொத்தையும் கண்காணிக்கவும் — பாதுகாப்பான தணிக்கை பதிவுகள் மற்றும் நேரடி நிலைத் தெரிவுடன்.",
    laundry_management: "துணி மேலாண்மை",
    // Nav
    "nav.dashboard": "முகப்பு",
    "nav.master_stock": "முதன்மை துணி இருப்பு",
    "nav.housekeeping": "தினசரி துப்புரவு பதிவு",
    "nav.rooms": "அறை வாரியான துணி நிலை",
    "nav.room_par": "அறை துணி பார்",
    "nav.laundry": "துணி துவைப்பு உள் / வெளி",
    "nav.store": "கிடங்கு இருப்பு",
    "nav.checkout": "வெளியேறும் அறை அழுக்கு துணி",
    "nav.missing_damaged": "காணாமல் / சேதம்",
    "nav.purchases": "கொள்முதல் பதிவேடு",
    "nav.consumption": "மாதாந்திர பயன்பாட்டு அறிக்கை",
    "nav.closing": "தினசரி இருப்பு எண்ணிக்கை",
    "nav.discrepancies": "முரண்பாடு மதிப்பாய்வு",
    "nav.assets": "சொத்து மேலாண்மை",
    "nav.admin": "நிர்வாக அமைப்புகள்",
    "nav.audit": "கண்காணிப்பு பதிவு",
    "nav.system": "அமைப்பு",
    // Auth
    "auth.sign_in": "உள்நுழை",
    "auth.sign_out": "வெளியேறு",
    "auth.enter_credentials": "தொடர உங்கள் விவரங்களை உள்ளிடுக.",
    "auth.email": "மின்னஞ்சல்",
    "auth.password": "கடவுச்சொல்",
    "auth.signing_in": "உள்நுழைகிறது…",
    "auth.welcome": "வருணா இன்னில் உங்களை வரவேற்கிறோம்",
    "auth.invalid": "தவறான விவரங்கள்",
    "auth.forgot_password": "கடவுச்சொல் மறந்துவிட்டதா?",
    "auth.forgot_title": "கடவுச்சொல்லை மீட்டமை",
    "auth.forgot_help": "உள்நுழையும் மின்னஞ்சலை உள்ளிடவும். கணக்கு இருந்தால், புதிய கடவுச்சொல் அமைக்க பாதுகாப்பான இணைப்பை நாங்கள் அனுப்புவோம்.",
    "auth.send_reset_link": "மீட்டமைப்பு இணைப்பை அனுப்பு",
    "auth.sending": "அனுப்புகிறது…",
    "auth.reset_link_sent": "மீட்டமைப்பு இணைப்பு அனுப்பப்பட்டது.",
    "auth.reset_check_email": "மீட்டமைப்பு இணைப்புக்கு உங்கள் மின்னஞ்சலை சரிபார்க்கவும்.",
    "auth.reset_sent_body": "அந்த மின்னஞ்சலுக்கு கணக்கு இருந்தால், ஒரு நிமிடத்திற்குள் மீட்டமைப்பு இணைப்பை பெறுவீர்கள். இணைப்பு 30 நிமிடங்களுக்கு மட்டும் செல்லுபடியாகும், ஒருமுறை மட்டுமே பயன்படுத்த முடியும்.",
    "auth.try_another_email": "வேறு மின்னஞ்சலை முயற்சி செய்",
    "auth.back_to_signin": "உள்நுழைவுக்குத் திரும்பு",
    "auth.reset_title": "புதிய கடவுச்சொல்லை தேர்வு செய்",
    "auth.reset_help": "நினைவில் வைக்க எளிதாகவும், மற்றவர்கள் யூகிக்க கடினமாகவும் ஒன்றை தேர்வு செய்யவும். குறைந்தபட்சம் 10 எழுத்துகள்.",
    "auth.new_password": "புதிய கடவுச்சொல்",
    "auth.confirm_password": "புதிய கடவுச்சொல்லை உறுதிப்படுத்து",
    "auth.reset_action": "கடவுச்சொல்லை மீட்டமை",
    "auth.resetting": "மீட்டமைக்கிறது…",
    "auth.reset_missing_token": "இந்த மீட்டமைப்பு இணைப்பில் டோக்கன் இல்லை. புதிய மீட்டமைப்பு மின்னஞ்சலை கோரவும்.",
    "auth.reset_success_body": "உங்கள் கடவுச்சொல் மீட்டமைக்கப்பட்டது. உள்நுழைவுக்கு திருப்பி விடப்படுகிறீர்கள்…",
    "auth.pwd_reset_ok": "கடவுச்சொல் புதுப்பிக்கப்பட்டது. இப்போது உள்நுழையலாம்.",
    "auth.pwd_min6": "கடவுச்சொல் குறைந்தபட்சம் 10 எழுத்துகள் இருக்க வேண்டும்.",
    "auth.pwd_min10": "கடவுச்சொல் குறைந்தபட்சம் 10 எழுத்துகள் இருக்க வேண்டும்.",
    "auth.pwd_mismatch": "கடவுச்சொற்கள் பொருந்தவில்லை.",
    "auth.pwd_same_as_current": "புதிய கடவுச்சொல் தற்போதைய கடவுச்சொல்லுக்கு வேறுபட வேண்டும்.",
    "auth.something_went_wrong": "ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்.",
    "auth.change_pwd_title": "உங்கள் கடவுச்சொல்லை மாற்று",
    "auth.change_pwd_help": "தற்போதைய கடவுச்சொல்லை உள்ளிட்டு புதியதை தேர்வு செய்யவும்.",
    "auth.first_login_pwd_help": "தொடர்வதற்கு முன் தற்காலிக கடவுச்சொல்லை மாற்ற வேண்டும்.",
    "auth.current_password": "தற்போதைய கடவுச்சொல்",
    "auth.change_pwd_action": "கடவுச்சொல்லை மாற்று",
    "auth.pwd_changed_ok": "கடவுச்சொல் மாற்றப்பட்டது.",
    "auth.saving": "சேமிக்கிறது…",
    // Roles
    "role.admin": "நிர்வாகி",
    "role.accounts": "கணக்குகள்",
    "role.hk_supervisor": "துப்புரவு மேற்பார்வையாளர்",
    "role.hk_staff": "துப்புரவு பணியாளர்",
    "role.laundry": "துணி துவைப்பு",
    "role.front_office": "வரவேற்பு",
    "role.maintenance": "பராமரிப்பு",
    // Nav additions
    "nav.maintenance": "பராமரிப்பு",
    "nav.warranty": "உத்தரவாதம் & AMC",
    // Columns (added)
    "col.item": "பொருள்",
    "col.qty": "அளவு",
    "col.date": "தேதி",
    "col.status": "நிலை",
    "col.remarks": "குறிப்புகள்",
    "col.reason": "காரணம்",
    "col.actions": "செயல்கள்",
    "col.by": "செய்தவர்",
    "col.role": "பங்கு",
    "col.attachment": "இணைப்பு",
    // Actions (added)
    "action.delete": "நீக்கு",
    "action.detail": "விவரம்",
    "action.export": "ஏற்றுமதி",
    "action.open": "திற",
    // Dashboard
    "dash.title": "மேலாண்மை முகப்பு",
    "dash.sub": "நிரந்தர பதிவு ஏட்டிலிருந்து நேரடியாக.",
    "kpi.total": "மொத்த துணி இருப்பு",
    "kpi.rooms": "அறைகளில் உள்ள துணி",
    "kpi.laundry_pending": "துவைப்பில் நிலுவை",
    "kpi.dirty": "அழுக்கு துணி",
    "kpi.store": "கிடங்கு இருப்பு",
    "kpi.available": "கிடைக்கும் இருப்பு",
    "kpi.missing": "காணாமல் போன துணி",
    "kpi.damaged": "சேதமான துணி",
    // Page subtitles
    "sub.master_stock": "ஒவ்வொரு இடத்திலும் பொருள் வாரியான நடப்பு கணக்கு.",
    "sub.housekeeping": "அறையில் வைத்த, எடுத்த, அழுக்காக கண்டுபிடித்த, காணாமல் / சேதமான துணிகளை பதிவு செய்யவும்.",
    "sub.rooms": "22 அறைகள் · குறைந்தபட்சம், நடப்பு சுத்தம், அழுக்கு எண்ணிக்கை.",
    "sub.laundry": "விற்பனையாளருக்கு அழுக்கு துணி அனுப்பி திரும்ப பெறவும்.",
    "sub.store": "வழங்க தயாராக உள்ள சுத்தமான துணி.",
    "sub.checkout": "வரவேற்பு அறையை 'வெளியேறியது/அழுக்கு' என குறிக்கும்போது உருவாகும் பணிகள்.",
    "sub.missing_damaged": "நிர்வாகி இழப்பை அங்கீகரிக்கும் வரை காணாமல் அறிக்கைகள் இருப்பை குறைக்காது. சேதமானவை அப்புறப்படுத்தும் வரை தனிமையில் இருக்கும்.",
    "sub.purchases": "புதிதாக பெற்ற இருப்பு. அங்கீகரிக்கப்பட்ட கொள்முதல் மட்டுமே மொத்த இருப்பை அதிகரிக்கும்.",
    "sub.consumption": "பயன்பாடு = அங்கீகரிக்கப்பட்ட இழப்பு + அப்புறப்படுத்தல்.",
    "sub.closing": "நேரடி எண்ணிக்கையை உள்ளிடவும். வேறுபாடு இருந்தால் குறிப்பு + மேற்பார்வையாளர் ஒப்புதல் தேவை.",
    "sub.admin": "விடுதி, பயனர்கள், பொருட்கள், அறைகள், குறைந்தபட்ச மதிப்புகள், விற்பனையாளர்கள் அமைப்புகள்.",
    "sub.audit": "ஒவ்வொரு உள்நுழைவு, சமர்ப்பிப்பு, ஒப்புதல், திருத்தம், அமைப்பு மாற்றமும்.",
    "low_stock_alerts": "குறைவான இருப்பு எச்சரிக்கை",
    "attention_needed": "இன்று கவனம் தேவை",
    "overdue_laundry": "காலம் தாழ்த்திய துவைப்பு",
    "unclosed_checkouts": "முடிக்கப்படாத வெளியேற்றங்கள்",
    "missing_closings": "விடுபட்ட தினசரி இருப்புகள்",
    "pending_approval": "மேற்பார்வையாளர் ஒப்புதலுக்காக நிலுவை",
    "chart.stock_by_location": "இட வாரியான இருப்பு",
    "chart.laundry_monthly": "மாதாந்திர துவைப்பு அனுப்பிய vs திரும்பியது",
    "chart.items_vs_threshold": "பொருள் வாரி கிடைப்பு vs குறைந்தபட்சம்",
    "chart.purchase_vs_consumption": "கொள்முதல் vs அங்கீகரிக்கப்பட்ட பயன்பாடு",
    // Common
    "col.room": "அறை", "col.vendor": "விற்பனையாளர்", "col.supplier": "வழங்குபவர்", "col.ref": "குறிப்பு எண்",
    "hk.op_date": "செயல்பாட்டு தேதி",
    "hk.room_status": "அறை நிலை மாற்று (விருப்பமானது)",
    "hk.line_items": "வரிசை பொருட்கள்",
    "hk.action": "செயல்",
    "hk.add_item": "மற்றொரு பொருள் சேர்",
    "hk.submit": "துப்புரவு பதிவை சமர்ப்பி",
    "hk.act.place": "அறையில் வை (கிடங்கிலிருந்து)",
    "hk.act.remove": "அறையிலிருந்து எடு (கிடங்கிற்கு)",
    "hk.act.dirty": "அழுக்கு (அழுக்கு சேமிப்பிற்கு)",
    "hk.act.missing": "காணாமல் என பதிவு",
    "hk.act.damage": "சேதம் என பதிவு",
    "lnd.tab.new": "புதிய அனுப்புகை",
    "lnd.tab.receive": "திரும்ப பெறு",
    "lnd.tab.history": "அனுப்புகை வரலாறு",
    "lnd.vehicle": "வாகனம் / ஓட்டுநர்",
    "lnd.items_dispatch": "அனுப்ப வேண்டிய பொருட்கள் (அழுக்கு சேமிப்பிலிருந்து)",
    "lnd.create_dispatch": "அனுப்புகையை உருவாக்கு",
    "lnd.return_date": "திரும்பிய தேதி",
    "lnd.move_to": "நகர்த்து",
    "lnd.returned_await": "திரும்ப காத்திருப்பு",
    "lnd.direct_store": "நேரடியாக சுத்த கிடங்கிற்கு",
    "lnd.dispatched": "அனுப்பியது",
    "lnd.outstanding": "நிலுவை",
    "lnd.received": "பெற்றது",
    "lnd.rejected": "நிராகரிக்கப்பட்டது/சேதம்",
    "lnd.missing": "காணாமல்",
    "lnd.submit_receipt": "பெறுதலை சமர்ப்பி",
    "lnd.attach_challan": "இணைப்பு (சலான் புகைப்படம் / PDF)",
    "lnd.attach_delivery": "இணைப்பு (டெலிவரி நோட் / PDF)",
    "pur.reference": "குறிப்பு / PO எண்",
    "pur.receive_into": "பெறும் இடம்",
    "pur.add_line": "வரிசை சேர்",
    "pur.attach": "இணைப்பு (விலைப்பட்டியல் புகைப்படம் / PDF)",
    "pur.record": "கொள்முதலை பதிவு செய்",
    "pur.line_items": "வரிசை பொருட்கள்",
    "cls.tab.new": "புதிய இருப்பு எண்ணிக்கை",
    "cls.tab.list": "வரலாறு & ஒப்புதல்",
    "cls.date": "இருப்பு தேதி",
    "cls.overall": "ஒட்டுமொத்த குறிப்புகள்",
    "cls.location": "இடம்",
    "cls.expected": "எதிர்பார்க்கப்படும் (அமைப்பு)",
    "cls.physical": "நேரடி எண்ணிக்கை",
    "cls.variance": "வேறுபாடு",
    "cls.remark": "குறிப்பு",
    "cls.submit": "நேரடி இருப்பை சமர்ப்பி",
    "action.save": "சேமி", "action.cancel": "ரத்து", "action.submit": "சமர்ப்பி",
    "action.add": "சேர்", "action.close": "மூடு", "action.approve": "ஒப்புதல்",
    "action.reject": "நிராகரி", "action.print": "அச்சிடு / PDF", "action.excel": "எக்செல்", "action.csv": "CSV",
    "search": "பொருள், அளவு, வகையை தேடு…",
    "loading": "ஏற்றுகிறது…",
    "language": "மொழி",
  },
};

const LANG_KEY = "vr_language";
const DEFAULT_LANG = "en";

const I18nCtx = createContext({ lang: DEFAULT_LANG, t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem(LANG_KEY) || DEFAULT_LANG; }
    catch (e) { console.warn("Language preference read failed:", e); return DEFAULT_LANG; }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem(LANG_KEY, l); }
    catch (e) { console.warn("Language preference save failed:", e); }
    document.documentElement.setAttribute("lang", l);
  }, []);

  useEffect(() => { document.documentElement.setAttribute("lang", lang); }, [lang]);

  const t = useCallback((key, fallback) => {
    const table = TRANSLATIONS[lang] || TRANSLATIONS.en;
    return table[key] ?? TRANSLATIONS.en[key] ?? fallback ?? key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
